export const statusOptions: StatusOptions[] = [
  {
    text: 'Active',
    value: 'active',
    type: 'status',
  },
  {
    text: 'Inactive',
    value: 'inactive',
    type: 'status',
  },
  {
    text: 'Preview',
    value: 'preview',
    type: 'status',
  },
  {
    text: 'Finalized',
    value: 'finalized',
    type: 'status',
  },
  {
    text: 'Checkout',
    value: 'checkout',
    type: 'status',
  },
  {
    text: 'Invoiced',
    value: 'invoiced',
    type: 'status',
  },
  {
    text: 'Completed',
    value: 'completed',
    type: 'status',
  },
  {
    text: 'Lost',
    value: 'lost',
    type: 'status',
  },
  {
    text: 'Cancelled',
    value: 'cancelled',
    type: 'status',
  },
  {
    text: 'Allocated',
    value: 'allocated',
    type: 'status',
  },
  {
    text: 'Partially Allocated',
    value: 'partially_allocated',
    type: 'status',
  },
  {
    text: 'Picked',
    value: 'picked',
    type: 'status',
  },
  {
    text: 'Partially Picked',
    value: 'partially_picked',
    type: 'status',
  },
  {
    text: 'Shipped',
    value: 'shipped',
    type: 'status',
  },
  {
    text: 'Partially Shipped',
    value: 'partially_shipped',
    type: 'status',
  },
  {
    text: 'Dispatched',
    value: 'dispatched',
    type: 'status',
  },
  {
    text: 'Partially Dispatched',
    value: 'partially_dispatched',
    type: 'status',
  },

];

export interface StatusOptions {
  text?: string,
  value?: string,
  type?: string,
}
